module.exports = require("plugin-generic-components/shared/components/components");